module.exports = __webpack_public_path__ + "img/delete.67b60f35.svg";